import AuthContainer from '../components/AuthContainer/AuthContainer.vue';
import ForgotPasswordPage from '../components/ForgotPasswordPage/ForgotPasswordPage.vue';
import ResetPasswordPage from '../components/ResetPasswordPage/ResetPasswordPage.vue';
import SignInPage from '../components/SignInPage/SignInPage.vue';
import ActivateUserPage from '../components/ActivateUserPage/ActivateUserPage.vue';

export default {
    path: '/',
    component: AuthContainer,
    meta: {
        unauthenticated: true
    },
    children: [
        {
            path: '/',
            component: SignInPage
        },
        {
            path: '/forgot-password',
            component: ForgotPasswordPage
        },
        {
            path: '/reset-password/:token',
            component: ResetPasswordPage
        },
        {
            path: '/activate-user/:token',
            component: ActivateUserPage
        }
    ]
};



// WEBPACK FOOTER //
// ./src/routes/routes-auth.js